import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

export const requestNotificationPermission = async () => {
    try {
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
            const token = await getToken(messaging, {
                vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY
            });
            return token;
        }
        throw new Error('Notification permission denied');
    } catch (error) {
        console.error('Error getting notification permission:', error);
        throw error;
    }
};

// export const onMessageListener = () => {
//     return new Promise((resolve) => {
//         onMessage(messaging, (payload) => {
//             console.log("payload", payload)
//             resolve(payload);
//         });
//     });
// }; 
// In firebase.ts
export const onMessageListener = () => {
    return new Promise((resolve) => {
        const unsubscribe = onMessage(messaging, (payload) => {
            // console.log("Message received in foreground", payload);
            unsubscribe(); // Clean up after first message
            resolve(payload);
        });

        // Timeout if no message received
        setTimeout(() => {
            unsubscribe();
            resolve(null);
        }, 10000); // 10 second timeout
    });
};